import { render, staticRenderFns } from "./EmpresasAsociadas.vue?vue&type=template&id=4400f790&scoped=true"
import script from "./EmpresasAsociadas.vue?vue&type=script&lang=js"
export * from "./EmpresasAsociadas.vue?vue&type=script&lang=js"
import style0 from "./EmpresasAsociadas.vue?vue&type=style&index=0&id=4400f790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4400f790",
  null
  
)

export default component.exports